import * as calendar from "./calendar";
import * as deliveryScheduling from "./deliveryScheduling";
import * as labelsFilter from "./labelFilter";
import * as orders from "./orders";
import * as requiredDateFilter from "./requiredDateFilter";
import * as searchFilter from "./searchFilter";
import * as sortFilter from "./sortFilter";
import * as userFilter from "./userFilter";

export const reducer = () => ({
  [deliveryScheduling.MODULE]: deliveryScheduling.reducer,
  [calendar.MODULE]: calendar.reducer,
  [orders.MODULE]: orders.reducer,
  [searchFilter.MODULE]: searchFilter.reducer,
  [sortFilter.MODULE]: sortFilter.reducer,
  [labelsFilter.MODULE]: labelsFilter.reducer,
  [userFilter.MODULE]: userFilter.reducer,
  [requiredDateFilter.MODULE]: requiredDateFilter.reducer,
});

export * as deliverySchedulingActions from "./deliveryScheduling/deliveryScheduling.actions";
export * as deliverySchedulingSelectors from "./deliveryScheduling/deliveryScheduling.selectors";

export default {};
